import keyMirror from "keymirror";

export default keyMirror({
  INIT_PRODUCTS: null,
});
